import { COLORS } from '../leaflet-map.constants';
import { ConnectorStats } from '../leaflet-map.types';

type GetIndicatorColor = (params: ConnectorStats) => string;

export const getIndicatorColor: GetIndicatorColor = ({
    unavailableConnectors,
    availableConnectors,
    totalConnectors,
    busyConnectors,
}) => {
    if (totalConnectors === undefined || totalConnectors === 0) {
        return COLORS.GREY;
    }

    if (availableConnectors !== undefined && availableConnectors >= 1) {
        return COLORS.SUCCESS_GREEN;
    }

    if (busyConnectors && busyConnectors >= 1) {
        return COLORS.BRAND_SECONDARY;
    }

    return COLORS.GREY;
};
